import React from "react";

const MARK = "/logo-mark.png";

// Real brand mark (concentric crescents: taupe / olive / terracotta).
export const Logo = ({ size = 44, className = "" }) => (
  <img
    src={MARK}
    alt="Praktijk De Kern logo"
    width={size}
    height={size}
    className={className}
    style={{ objectFit: "contain" }}
  />
);

export const Wordmark = ({ className = "", light = false, sub = true }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <Logo size={56} />
    <div className="leading-none text-left">
      <div
        className="font-serif text-2xl tracking-tight"
        style={{ color: light ? "#F7F4EE" : "#4F5048" }}
      >
        De Kern
      </div>
      {sub && (
        <div
          className="text-[10px] tracking-[0.18em] uppercase mt-1 leading-relaxed"
          style={{ color: light ? "#DCE0D5" : "#8A8176" }}
        >
          <span className="block">Praktijk voor gezinstherapie</span>
          <span className="block">&amp; individuele begeleiding</span>
        </div>
      )}
    </div>
  </div>
);
